/**
 * [懒猪学院]
 * @author: Fu Xiaochun
 * @date: 2021-08-23 
 */

import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { Button, message } from 'antd';
import { connect } from 'react-redux';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import { Modal, Form, Input, Radio,  } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import TableBox from './components/TableBox';
import http from '@/assets/api/http';
import * as api from '@/apis/client/school';
import LessionTypeModal from './components/LessionTypeModal';
import LessionMoveModal from './components/LessionMoveModal';

function School(props){

    const [lessions, setLessions] = useState([]);
    const [expKeys, setExpKeys] = useState([]);
    const [classVisible, setClassVisible] = useState(false);
    const [moveVisible, setMoveVisible] = useState(false);
    const [curMoveLession, setCurMoveLession] = useState({});
    const [moveClass, setMoveClass] = useState();
    const [classInfo, setClassInfo] = useState({});
    const [classList, setClassList] = useState([]);

    useEffect(()=>{
        // 设置面包屑导航
        props.setBreadcrumbPaths(props.match);

        getList();
        
    }, []);

    const getList = ()=>{
        api.getLessions().then(res=>{
            adaptLession(res.result);
            filterClass(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const adaptLession = (list)=>{
        let temp = list.map(v=>{
            if(v.children.length){
                v.children = v.children.map(item=>{
                    if(item.pid != 0 && item.children){
                        delete item.children;
                    }
                    return item;
                });
            }
            return v;
        });
        setLessions(temp);
    };

    const filterClass = (list)=>{
        let temp = [];
        let expIds = [];
        list.forEach(v=>{
            if(v.pid == 0){
                temp.push(v);
                expIds.push(v.id);
            }
        });
        setClassList(temp);
        setExpKeys(expIds);
    };

    const toggleExplan = (status)=>{
        let ids = classList.map(v=>{
            return v.id;
        });
        if(status){
            setExpKeys(ids);
        }else{
            setExpKeys([]);
        }
    };

    const onTableOperate = (id, type, item)=>{
        switch (type){
            case 'expand': 
                {
                    if(id){
                        setExpKeys([...expKeys, item.id]);
                    }else{
                        setExpKeys(expKeys.filter(v=>v != item.id));
                    }
                }
                break;
            case 'edit':
                // 编辑
                if(item.pid != 0){
                    props.history.push('/home/client/school/editLession/'+item.id);
                }else{
                    onEditClass(item);
                }
                break;
            case 'delete': 
                // 删除
                {
                    if(item.pid == 0){
                        Modal.confirm({
                            title: null,
                            icon: null,
                            content: '删除分类将删除其下所有课程，确定删除吗？',
                            onOk() {
                                api.deleteClass({id: item.id}).then(res=>{
                                    message.success('删除成功');
                                    getList();
                                }).catch(err=>{
                                    message.error(err.message);
                                });
                            },
                            onCancel() {
                                //
                            },
                        });
                    }else{
                        Modal.confirm({
                            title: null,
                            icon: null,
                            content: '确定删除此课程吗？',
                            onOk() {
                                api.deleteLession({id: item.id}).then(res=>{
                                    message.success('删除成功');
                                    getList();
                                }).catch(err=>{
                                    message.error(err.message);
                                });
                            },
                            onCancel() {
                                console.log('Cancel');
                            },
                        });
                    }
                }
                break;
            case 'move':
                // 移动
                onMoveLession(item);
                break;
            default:
                // nothing to do
        }
    };

    const onEditClass = (item)=>{
        setClassInfo({
            id: item.id,
            name: item.name,
            studyPurpose: item.studyPurpose
        });
        setClassVisible(true);
    };

    const addClass = ()=>{
        setClassVisible(true);
        setClassInfo({});
    };

    const onClassSave = ()=>{
        setClassVisible(false);
        setClassInfo({});
        getList();
    };

    const onClassCancel = ()=>{
        setClassVisible(false);
        setClassInfo({});
    };

    const addLession = ()=>{
        props.history.push('/home/client/school/addLession');
    };


    const onMoveLession = (item)=>{
        setMoveVisible(true);
        setCurMoveLession(item);
    };

    const onMoveSave = ()=>{
        getList();
        setMoveVisible(false);
    };

    const onMoveCancel = ()=>{
        setMoveVisible(false);
    };

    return (
        <div>
            <div className={styles.handleBox}>
                <Button className={styles.btn} type="primary" onClick={addClass}>新增课程类型</Button>
                <Button className={styles.btn} type="primary" onClick={addLession}>新增课程</Button>
                <Button className={styles.btn} type="primary" onClick={()=>{toggleExplan(true);}}>展开所有</Button>
                <Button className={styles.btn} type="primary" onClick={()=>{toggleExplan(false);}}>折叠所有</Button>
            </div>
            <div className="list">
                <TableBox
                    lessions={lessions}
                    onTableOperate={onTableOperate}
                    expKeys={expKeys}
                    getList={getList}
                />
            </div>
            {classVisible ? <LessionTypeModal lessionTypeInfo={classInfo} onOk={onClassSave} onClose={onClassCancel} /> : null}
            {moveVisible ? <LessionMoveModal lession={curMoveLession} classList={classList} onOk={onMoveSave} onClose={onMoveCancel} /> : null}
        </div>
    );
}

School.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(School);